import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../axiosBaseQuery';

export const reviewApi = createApi({
  reducerPath: 'reviewApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Queue'],
  endpoints: build => ({
    getReviewQueue: build.query({
      query: ({ field, status, page }) => ({
        url: '/review/queue',
        params: {
          field: field || undefined,
          status: status && status !== 'pending' ? status : undefined,
          page: page > 1 ? page : undefined
        }
      }),
      providesTags: ['Queue']
    }),
    reviewStone: build.mutation({
      query: ({ id, review }) => ({
        url: `/stones/${id}/review`,
        method: 'patch',
        data: { review },
        skipErrorModal: true
      }),
      invalidatesTags: ['Queue']
    }),
    bulkApprove: build.mutation({
      query: body => ({
        url: '/review/bulk-approve',
        method: 'post',
        data: body,
        skipErrorModal: true
      }),
      invalidatesTags: (result, error, { dry_run }) => (dry_run ? [] : ['Queue'])
    })
  })
});

export const { useGetReviewQueueQuery, useReviewStoneMutation, useBulkApproveMutation } =
  reviewApi;
